import type {LocaleCode} from '../../../shared/locale/locales'
import locales from '../../../shared/locale/locales'

export const isSupportedLocale = (localeCode: string): localeCode is LocaleCode =>
    locales.some((locale) => locale.code === localeCode)
